module.exports = __webpack_public_path__ + "img/ml-logo.7afa50ca.png";